import { HTTPService, createHtppServiceInstance } from "./httpManager.js";
import { Config } from "../config/config.js";
import { MetaDataHelper } from "./metaDataHelper.js";
import { Helper } from "./helper.js";

export class DatasourceUrlProcessor {
    private _icuh = Helper;

    public processTemplate = (datasourceUrl: string, handleEval): string => {
        try {
            if (this.dataSourceUrlHasTemplate(datasourceUrl)) {
                datasourceUrl = this._icuh.processTemplate(datasourceUrl, ((match) => {
                    const result = handleEval(match);
                    if (Helper.hasValue(result)) {
                        return encodeURIComponent(result);
                    } else {
                        return "";
                    }
                }));
            }
        } catch (ex) {
            console.error("Could not process dataSourceUrl teplate. " + ex)
        }
        return datasourceUrl;
    }

    public dataSourceUrlHasTemplate = (datasourceUrl: string): boolean => {
        if (this._icuh.hasValue(datasourceUrl) && datasourceUrl.indexOf("{") != -1) {
            return true;
        }
        return false;
    }
}